<mat-card class="featured_boxes">
  <mat-card-title>{{ element.title }}</mat-card-title>
  <mat-card-content class="card-action__content">
    <p id="description" [ngClass]="hasURL ? 'featured__description--two-lines' : 'featured__description--six-lines'">
      {{ element.description }}
    </p>
    <div *ngIf="hasURL && !isExternalUrl">
      <p class="p_pdf">
        {{ ('training.format' | translate) + ' ' + element.type }}
      </p>
      <p *ngIf="!isExternalUrl" class="p_pdf">{{ size + ' KB' }}</p>
    </div>
  </mat-card-content>
  <mat-card-actions class="card-action__buttons">
    <div *ngIf="hasURL && !isVideo; else viewMore">
      <button mat-stroked-button (click)="onClickViewDocument()">
        <mat-icon class="icon-ic_visibility"></mat-icon>
        <mat-label>{{ 'training.view.document' | translate | uppercase }}</mat-label>
      </button>
      <button
        *ngIf="!isExternalUrl"
        class="download_button"
        mat-stroked-button
        color="accent"
        (click)="onClickDownloadDocument()"
      >
        <mat-icon class="icon-ic_file_download"></mat-icon>
      </button>
    </div>
    <ng-template #viewMore>
      <button
        *ngIf="isExternalUrl"
        mat-stroked-button
        color="accent"
        (click)="onClickViewMore()"
        class="featured-button__view-more"
      >
        <mat-label>{{
          isViewMoreClicked
            ? ('training.view.more' | translate | uppercase)
            : ('training.view.less' | translate | uppercase)
        }}</mat-label>
      </button>
    </ng-template>
  </mat-card-actions>
</mat-card>
